import React, { type FC } from 'react'
import { ButtonGroup } from '@mui/material'

import { Button } from '../common'

export const SplitButtonControl = <Option extends string>({
    ariaLabel,
    testIdPrefix,
    option,
    options,
    onChange,
}: Readonly<{ ariaLabel: string, testIdPrefix: string, option: Option, options: readonly Option[], onChange: (option: Option) => void }>): ReturnType<FC> => (
    <ButtonGroup aria-label={ariaLabel} sx={{ mb: 4, textTransform: 'capitalize' }}>
        {options.map((candidate) => (
            <Button
                key={candidate}
                data-testid={`${testIdPrefix}-${candidate}`}
                variant={candidate === option ? 'primary' : 'primaryOutline'}
                onClick={() => onChange(candidate)}
            >
                {candidate}
            </Button>
        ))}
    </ButtonGroup>
)
